import { postJson } from "../../utils/utils";
import { setSchoolManagers } from "./schoolManager-slice";

export const fetchSchoolMembersThunk = (schoolId) => async (dispatch) => {
    try {
        const res = await postJson(`${window.config.baseApiUrl}/api/schoolManager/filterSchoolManagers?schoolId=${schoolId}`);
        dispatch(setSchoolManagers(res?.body ?? []));
    } catch (e) {
        console.error("error fetchSchoolMembersThunk", e);
    }
};

export const removeSchoolAdminThunk = (schoolId, userId) => async () => {
    try {
        const res = await postJson(`${window.config.baseApiUrl}/api/schoolManager/delete?schoolId=${schoolId}&userId=${userId}`);
        return res?.ok ?? false;
    } catch (e) {
        console.error("error removeSchoolAdminThunk", e);
        return false;
    }
};

export const addSchoolAdminThunk = (schoolId, schoolName, userId, permissionLevelId) => async () => {
    try {
        const res = await postJson(`${window.config.baseApiUrl}/api/schoolManager/add`,
            { schoolId, schoolName, userId, permissionLevelId });
        return res?.ok ?? false;
    } catch (e) {
        console.error("error addSchoolAdminThunk", e);
        return false;
    }
};
